import React, { useEffect, useState } from 'react';
var interval: any = null
const SpecialDraggedItemUI = (props: any) => {
	const [positionData, setPositionData] = useState({top: -1, left: -1, img: null});
	useEffect(() => {
		if(!interval) {
			interval = setInterval(() => {
				if((window as any)['currentDraggedItemPositionData']) {
					setPositionData((window as any)['currentDraggedItemPositionData']);
				}
			}, 50);
		}
		
		return () => {
			if(interval) {
				clearInterval(interval);
				interval = null;
			}
		}
	}, []);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			{positionData.img ? (
				<img style={{
					transform: 'scale(' + props.scale + ')',
					position: 'absolute',
					left: positionData.left - (218/2) + 'px',
					top: positionData.top - (144/2)  + 'px'
				}} src={positionData.img} alt="" />
			) : (null)}
		</div>
	);

};
export default SpecialDraggedItemUI;